import { useEffect, useState } from "react";
import {
  useStripe,
} from "@stripe/react-stripe-js";
import { useNavigate } from "react-router";
import axios from "axios";
import { toast } from "react-toastify";

import { API } from "../../../backend";
import authHeader from "../../../services/auth-header";
import Helper from "../../../Helper";

function ConfirmExisting() {
  const [pwd, setPassword] = useState("");
  const [message, setMessage] = useState(null);
  const navigate = useNavigate()
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const value = urlParams.get('value');
  const sessionid = urlParams.get('session_id');

  const stripe = useStripe();

  const generatePassword = () => {
    const uppercaseLetter = String.fromCharCode(65 + Math.floor(Math.random() * 26)); // Random uppercase letter
    const lowercaseLetters = Array.from({ length: 2 }, () => String.fromCharCode(97 + Math.floor(Math.random() * 26))).join(''); // Random two lowercase letters
    const digits = Math.floor(100 + Math.random() * 900); // Random three-digit number

    const newPassword = uppercaseLetter + lowercaseLetters + '@' + digits;
    setPassword(newPassword);
  };

  useEffect(() => {
    generatePassword();
  }, []);
  
  // const handleSuccess = async (paymentId) => {
  //   await axios.post(API + 'accounting/paymentretrieve/', { paymentId: paymentId },
  //     {
  //       headers: authHeader()
  //     }).then((response) => {
  //       if (response.data.success === 1) {
  //         const plan = response.data.response.metadata.plan;
  //         const ipAddress = response.data.response.metadata.ip_address;
  //         const userallow = response.data.response.metadata.userallow
  //         const start_date = response.data.response.metadata.start_date
  //         const end_date = response.data.response.metadata.end_date
  //         const transaction_id = response.data.response.metadata.transaction_id
  //         const userid = localStorage.getItem("userid")
  //         const companyid = localStorage.getItem("companyid")
  //         const body = {
  //           company: companyid,
  //           user: userid,
  //           transaction_id: transaction_id,
  //           payment_id: response.data.response.id,
  //           payment_type: response.data.response.payment_method_types,
  //           mode_of_payment: '',
  //           amount: response.data.response.amount,
  //           sub_total: response.data.response.amount,
  //           tax: 0,
  //           total: response.data.response.amount,
  //           status: response.data.response.status,
  //           ip_address: ipAddress,
  //           start_date: start_date,
  //           end_date: end_date,
  //           plan: plan,
  //           updated_at: response.data.response.created,

  //         }

  //         const bodyy = {
  //           plan: plan,
  //           userallow: userallow
  //         }
  //         axios.post(API + 'accounting/payment/', body,
  //           {
  //             headers: authHeader()
  //           })
  //           .then((res) => {
  //             if (res.data.success === 1) {
  //               const data={
  //                 plan:plan,
  //                 start_date :res.data.start_date,
  //                 end_date:res.data.end_date,
  //                 company:res.data.company
  //               }
  //               const pid = res.data.payment_id
  //               if(value === 'upgrade'){
  //                 axios.post(API + `accounting/subscriptionpaymentadd/${pid}/`,data)
  //               }
  //                 axios.post(API + `accounting/planuserupdate/`,
  //                   bodyy,
  //                   { headers: authHeader() }).then((res) => {
  //                     if (res.data.success === 1) {
  //                       GetCompanyInfoService.getCompanyInfo().then(
  //                         (response) => {
  //                           // setCompany(response.data)
  //                           // setAdduser(false)
  //                         })
  //                     }
  //                   }
  //                   )
  //                 const bodyyy= {'session_id':
  //                 sessionid}
  //               axios.post(API + `accounting/stripesubscriptionmodyfiy/`,
  //                 bodyyy,
  //                 { headers: authHeader() }).then((res) => {
  //                 }
  //                 )
  //               setTimeout(() => {
  //                 navigate('/payment')
  //               }, 4000);
  //             }
  //           })

  //       }
  //     })

  // }

  const handleSuccess = async (paymentId) => {
    await axios.post(API + 'paymentsub/retrieve-payment-intent/', { payment_intent_id: paymentId },
      {
        headers: authHeader()
      }
    ).then((response) => {
      if (response.data.success === 1) {
          const date = new Date('YYYY-MM-DD')
          const sub_id=sessionid
          const payment_date= date
          const cheque_no = null
          const bank_name = null
          const cheque_date = null
          const payment_method = response.data.payment_intent.payment_method_types[0]
          const payment_gateway = "stripe"
          const payment_ref = response.data.payment_intent.id
          const payment_status = response.data.payment_intent.status
          const amount = response.data.payment_intent.amount/100
          const userallows = response.data.payment_intent.metadata.userallow
          const add_user = response.data.payment_intent.metadata.add_user
          const paymentdate = payment_status === "succeeded" ? Helper.DatePicker(new Date()) : null
          
          axios.post(API + 'paymentsub/subscription/payment/',{
            sub_id,
            payment_date : paymentdate,
            cheque_no,
            bank_name,
            cheque_date,
            payment_method,
            payment_gateway,
            payment_ref,
            payment_status,
            no_of_user:add_user,
            total_amount : amount
          },
          {
            headers: authHeader()
          }).then((res) =>{
            if(res.data.success === 1){
                axios.put(API + 'paymentsub/subscription/',{
                  id :  sessionid,
                  no_of_users : userallows
                },
                {
                  headers: authHeader()
                }).then((respo) =>{
                 if(respo.data.success === 1) {
                  navigate('/payment')
                 }
                })
            }
          })
        }
      })

  }

  useEffect(() => {
    if (!stripe) {
      return;
    }

    const clientSecret = new URLSearchParams(window.location.search).get(
      "payment_intent_client_secret"
    );

    if (!clientSecret) {
      return;
    }


    stripe.retrievePaymentIntent(clientSecret).then(({ paymentIntent }) => {
      const paymentId = paymentIntent.id
      handleSuccess(paymentId)
      switch (paymentIntent.status) {
        case "succeeded":
          setMessage("Payment succeeded!");
          break;
        case "processing":
          setMessage("Your payment is processing.");
          break;
        case "requires_payment_method":
          setMessage("Your payment was not successful, please try again.");
          break;
        default:
          setMessage("Please log a support ticket or send email to support@athenafintech.com.");
          break;
      }
    })
  }, [stripe]);
  return (
    <>
      <div className="container-fluid pt-8">
        <div className="cardsucess bodysucess justify-content-center">
          <div className="divsucess" style={{ height: '100px', width: '100px' }}>
            <i className="checkmark isucess" style={{ lineHeight: '100px', fontSize: '50px', marginLeft: '-7px' }}>✓</i>
          </div>

          <h1 className="hsucess">Your payment success!</h1>
          <p className="psucess">Thank you for your payment. Your transaction has been processed successfully.
            Please check your email for login instructions.</p><br />
        </div>
      </div>
    </>
  );
}

export default ConfirmExisting;